import { useCallback } from 'react';
import { NIFTY_500_SYMBOLS } from '../constants/nifty500Symbols';

const normalizeSymbol = (symbol: string) => symbol.trim().toUpperCase();
const NIFTY_500_SYMBOLS_SET = new Set(NIFTY_500_SYMBOLS.map(normalizeSymbol));

export const useNifty500Symbols = () => {
  const isNifty500Symbol = useCallback((symbol?: string | null) => {
    if (!symbol) {
      return false;
    }

    return NIFTY_500_SYMBOLS_SET.has(normalizeSymbol(symbol));
  }, []);

  return {
    symbols: NIFTY_500_SYMBOLS_SET,
    isNifty500Symbol,
  };
};
